import React from "react"

import FoodModalOptionGroup from "./FoodModalOptionGroup"
import classes from "./index.module.scss"

const FoodModalOptions = props => {
  const { form, setForm, specifications, customBuilder } = props

  const getSpecificationMaxSelect = specificationId => {
    const step =
      (customBuilder?.steps || []).find(builderStep =>
        String(builderStep.specificationId) === String(specificationId)
      )

    return step?.maxSelect
  }

  return (
    <div className={classes["container"]}>
      {specifications.map(specification =>
        <FoodModalOptionGroup
          key={specification._id}
          form={form}
          setForm={setForm}
          specification={specification}
          maxSelect={getSpecificationMaxSelect(specification._id)}
        />
      )}
    </div>
  )
}

export default FoodModalOptions
